import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.6 19a.7.7 0 0 1 .7-.7h3.481l-.722-.845a.7.7 0 1 1 1.065-.91l1.708 2a.7.7 0 0 1 0 .91l-1.708 2a.7.7 0 0 1-1.065-.91l.722-.845H18.3a.7.7 0 0 1-.7-.7ZM6.935 9.404c-.48.627-.798 1.526-.798 2.55 0 1.023.318 1.922.798 2.55.479.626 1.087.95 1.702.95s1.223-.324 1.702-.95c.48-.628.798-1.527.798-2.55 0-1.024-.318-1.923-.798-2.55-.479-.626-1.087-.95-1.702-.95s-1.223.324-1.702.95Zm-1.192-.91c.697-.913 1.714-1.54 2.894-1.54 1.18 0 2.197.627 2.894 1.54.696.91 1.106 2.136 1.106 3.46 0 1.323-.41 2.55-1.106 3.46-.697.912-1.714 1.54-2.894 1.54-1.18 0-2.197-.628-2.894-1.54-.697-.91-1.106-2.136-1.106-3.46 0-1.324.41-2.55 1.106-3.46ZM15.781 9.404c-.479.627-.797 1.526-.797 2.55 0 1.023.318 1.922.797 2.55.48.626 1.088.95 1.703.95s1.223-.324 1.702-.95c.48-.628.798-1.527.798-2.55 0-1.024-.318-1.923-.798-2.55-.479-.626-1.087-.95-1.702-.95s-1.223.324-1.703.95Zm-1.191-.91c.697-.913 1.714-1.54 2.894-1.54 1.18 0 2.196.627 2.894 1.54.696.91 1.106 2.136 1.106 3.46 0 1.323-.41 2.55-1.106 3.46-.698.912-1.714 1.54-2.894 1.54-1.18 0-2.197-.628-2.894-1.54-.697-.91-1.106-2.136-1.106-3.46 0-1.324.41-2.55 1.106-3.46Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M4.516 16.046a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
